import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pipeline-destinations-name-validator"
export default class extends Controller {
  static targets = [ "name", "remark" ];

  connect() {
  }

  async nameInput() {
    let response = await fetch(
      this.nameTarget.dataset.validatePath + "?" +  new URLSearchParams({
        name: this.nameTarget.value
      })
    );

    let result = JSON.parse(await response.text());

    if (result.name.unique) {
      this.remarkTarget.innerHTML = this.badge("success", "Valid");
    }
    else {
      this.remarkTarget.innerHTML = this.badge("warning", "Already Exists");
    }
  }

  badge(status, label) {
    return `<span class="badge ${status}">
      <svg class="h-1.5 w-1.5" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
      </svg>
      ${label}
    </span>`;
  }
}
